function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { formatTimestamp } from './utils/format';
import levels from './levels';
var defaultLevel = process.env.NODE_ENV === 'production' ? 'info' : 'debug';

var Logger = /*#__PURE__*/function () {
  function Logger() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Logger);

    this.options = options;
    this.module = options.module || 'global';
    this.providers = options.providers || [];
    this.levels = options.levels || levels;
    this.level = (options.level || defaultLevel).toLowerCase();
    this.levelCode = this.levels[this.level];

    if (typeof this.levelCode !== 'number') {
      throw new TypeError("Unknown logger level: ".concat(this.level));
    } // wrap logger functions


    for (var level in this.levels) {
      this[level] = this.wrapFn(level);
    }
  }

  _createClass(Logger, [{
    key: "wrapFn",
    value: function wrapFn(level) {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (typeof this.beforeLog === 'function') {
          this.beforeLog.apply(this, [level].concat(args));
        }

        var timestamp = formatTimestamp(new Date());
        var prefix = "[".concat(timestamp, "][").concat(level.toUpperCase(), "][").concat(this.module, "]");

        if (typeof args[0] === 'string') {
          args[0] = prefix + ' ' + args[0];
        } else {
          args.unshift(prefix);
        }

        this.providers.forEach(function (provider) {
          return provider[level].apply(provider, args);
        });
      };
    }
  }, {
    key: "getLogger",
    value: function getLogger() {
      throw new Error('Not Implemented');
    }
  }]);

  return Logger;
}();

export { Logger as default };